function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.778 13H7.223",
  stroke: "gray",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12.25,
  stroke: "gray",
  strokeWidth: 1.5
});

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "d5565f4fa4d025f587d37bbe66593f66.svg";
export { SvgMinus as ReactComponent };